import axios from 'axios'
import {
  call,
  cancel,
  cancelled,
  fork,
  put,
  select,
  take,
} from 'redux-saga/effects'

import { SHOP_CLAIM } from '../../app/constants'
import { setShopItems } from '../../features/shopItems/shopItemsSlice'

// Query shop items
export function getShopItemsData(user) {
  return new Promise(async (resolve, reject) => {
    try {
      const { rows } = await user.userAccount.rpc.get_table_rows({
        json: true,
        code: SHOP_CLAIM,
        scope: SHOP_CLAIM,
        table: 'shopconfigs',
        limit: 100,
      })

      resolve(rows)
    } catch (error) {
      reject(error)
    }
  })
}

export function getShopItemsDetails(shopIds) {
  return new Promise(async (resolve, reject) => {
    try {
      const collection = await axios.get(
        // Mainnet
        // 'https://wax.api.atomicassets.io/atomicassets/v1/templates?collection_name=galaktikanft&limit=1000&order=desc&sort=name'
        //  Testnet
        `https://test.wax.api.atomicassets.io/atomicassets/v1/templates?collection_name=galaktiktest&limit=${
          shopIds.length
        }&ids=${shopIds.join(',')}`,
      )
      const data = collection.data.data.map((e) => {
        const obj = e.immutable_data
        obj.template_id = e.template_id
        return obj
      })
      console.log(collection.data.data)
      resolve(data)
      return collection
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveShopItems() {
  const { user } = yield select()
  console.log('DEBUGGING user:', user)

  try {
    const shopItemsData = yield call(getShopItemsData, user)
    const shop_ids = shopItemsData.map((e) => e.template_id)
    const shopItemsDetails = yield call(getShopItemsDetails, shop_ids)
    const info = shopItemsData.map((e) => {
      const data = e
      const details = shopItemsDetails.find(
        (i) => +i.template_id === +e.template_id,
      )

      return {
        data,
        details
      }
    })
    // const info = { data: shopItemsData, details: shopItemsDetails }

    yield put(
      setShopItems({
        type: 'FETCHING_SUCCESS',
        info,
      }),
    )
  } catch (error) {
    const errorMsg = error.toString()
    yield put(setShopItems({ type: 'FETCHING_ERROR', error: errorMsg }))
  } finally {
    if (yield cancelled()) {
      yield put(setShopItems({ type: 'FETCHING_CANCELLED' }))
    }
  }
}

export function* shopItemsFlow() {
  while (true) {
    yield put(setShopItems({ type: 'GET_EPOCH_START' }))
    const task = yield fork(resolveShopItems)
    const action = yield take(['FETCHING_ERROR'])
    if (action.type === 'STOP_FETCHING') {
      yield cancel(task)
    }
  }
}
